import styled from 'styled-components';

export const InternalServerErrorContainer = styled.div`
  background-color: ${({ theme }) => theme.COLORS.secondaryLight};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  padding: 20vh 1.5rem 0 1.5rem;

  h1 {
    font-size: 10rem;
    margin: 0 0 4rem 0;
    line-height: 8rem;
    font-weight: 500;
    color: ${({ theme }) => theme.UI_COLORS.secondary};
  }

  h2 {
    color: ${({ theme }) => theme.UI_COLORS.secondary};
    font-size: ${({ theme }) => theme.TYPOGRAPHY.h2.fontSize};
    font-weight: ${({ theme }) => theme.TYPOGRAPHY.h2.fontWeight};
    margin: 0 0 1.5rem 0;
  }

  a {
    font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontSize};
    font-weight: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontWeight};
    color: ${({ theme }) => theme.UI_COLORS.primary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
